import React from 'react'
import PinCodeInput from '../PinCodeInput'

export default ({ field, form, helperText, ...props }) => {
  const error = form.errors[field.name]
  const touched = form.touched[field.name]
  const showError = touched && !!error

  return (
    <PinCodeInput
      {...props}
      disabled={form.isSubmitting}
      name={field.name}
      error={showError}
      helperText={showError ? error : helperText}
      // if you are using custom validation schema you probably want to pass `true` as third argument
      onComplete={(value) => form.setFieldValue(field.name, value, true)}
    />
  );
};
